import { ufologger } from '@atlassian/ufo-experimental';
import { getPerformanceObject, getPerformanceObserverObject } from '../../utils/window-helper';
export const resourceTimingBuffer = {
  timings: [],
  maxSize: 1000,
  observer: null,
  transformResource: entry => ({
    name: entry.name,
    initiatorType: entry.initiatorType,
    transferSize: entry.transferSize,
    startTime: Math.round(entry.startTime),
    duration: Math.round(entry.duration),
    fetchStart: Math.round(entry.fetchStart || 0),
    workerStart: Math.round(entry.workerStart || 0),
    responseStart: Math.round(entry.responseStart || 0)
  }),
  start: (performance = getPerformanceObject(), PerformanceObserver = getPerformanceObserverObject()) => {
    var _performance$getEntri;
    if (!PerformanceObserver || !performance || typeof PerformanceObserver === 'undefined') {
      return;
    }
    if (resourceTimingBuffer.observer) {
      ufologger.warn('Observer is already running');
      return;
    }
    const resources = (_performance$getEntri = performance.getEntriesByType) === null || _performance$getEntri === void 0 ? void 0 : _performance$getEntri.call(performance, 'resource');
    if (resources) {
      resourceTimingBuffer.timings = resources.map(resource => resourceTimingBuffer.transformResource(resource));
    }
    resourceTimingBuffer.observer = new PerformanceObserver(resourceTimingBuffer.addTimings);
    resourceTimingBuffer.observer.observe({
      entryTypes: ['resource']
    });
  },
  stop: () => {
    if (resourceTimingBuffer.observer) {
      resourceTimingBuffer.observer.disconnect();
      resourceTimingBuffer.observer = null;
    }
    resourceTimingBuffer.timings = [];
  },
  addTimings: list => {
    const entries = list.getEntries().map(entry => resourceTimingBuffer.transformResource(entry));
    const overflow = resourceTimingBuffer.timings.length + entries.length;
    if (overflow > resourceTimingBuffer.maxSize) {
      const fieldsToRemove = overflow - resourceTimingBuffer.maxSize;
      resourceTimingBuffer.timings.splice(0, fieldsToRemove);
    }
    resourceTimingBuffer.timings.push(...entries);
  }
};
export const getResourceTimings = (startTime, performance = getPerformanceObject()) => {
  if (!PerformanceObserver || !resourceTimingBuffer.observer) {
    const resources = performance === null || performance === void 0 ? void 0 : performance.getEntriesByType('resource');
    if (resources) {
      return resources.filter(timing => timing.startTime >= startTime);
    }
    return null;
  }
  return resourceTimingBuffer.timings.filter(timing => timing.startTime >= startTime);
};